const queryPrefix = 'certificates'

export const CertificatesQueryKeys = {
  Certificate: `${queryPrefix}/certificate`,
  Certificates: `${queryPrefix}/certificates`,
  CertificateTypes: `${queryPrefix}/certificate-types`,
  CertificateTypesAll: `${queryPrefix}/certificate-types-all`,
  CertificateCategories: `${queryPrefix}/certificate-categories`,
  Locations: `${queryPrefix}/locations`,
} as const
